export interface Channel {
  id: string;
  name: string;
  cover: string;
  short: string;
  intro: string;
  tags: string[];
  reason: string;
  stats: string;
}

export const channels: Channel[] = [
  {
    id: "c1",
    name: "黑桃影厅",
    cover: "https://readdy.ai/api/search-image?query=elegant%20home%20cinema%20room%20with%20large%20screen%20and%20warm%20amber%20ambient%20lighting%2C%20dark%20interior%2C%20premium%20cinematic%20mood%2C%20high%20detail&width=800&height=500&seq=ht-ch-c1&orientation=landscape",
    short: "黑桃出品，院线级大片精选",
    intro: "黑桃影厅是本站的旗舰频道，聚合年度口碑电影与院线佳作。我们以严格的选片标准，为影迷提供从科幻、悬疑到剧情片的多元观影清单，并附上深度剧情导览与看点解析。",
    tags: ["院线大片", "高口碑", "深度解析"],
    reason: "片源筛选严格、类型覆盖全面，是快速找到高质量电影的首选入口。",
    stats: "精选影片 320+ · 每周更新",
  },
  {
    id: "c2",
    name: "星辉剧场",
    cover: "https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20tv%20showing%20a%20drama%20series%2C%20warm%20evening%20orange%20light%2C%20comfortable%20sofa%2C%20relaxed%20binge%20watching%20atmosphere&width=800&height=500&seq=ht-ch-c2&orientation=landscape",
    short: "热播剧集一站追更",
    intro: "星辉剧场专注电视剧领域，覆盖都市、年代、悬疑、青春等主流题材。频道提供更新日历与追剧提醒式导览，帮助你不错过任何一集的精彩内容。",
    tags: ["热播剧", "追更日历", "多题材"],
    reason: "更新及时、题材齐全，追剧党的信息中枢。",
    stats: "在追剧集 180+ · 每日更新",
  },
  {
    id: "c3",
    name: "深夜电影台",
    cover: "https://readdy.ai/api/search-image?query=moody%20late%20night%20cinema%20with%20a%20film%20projector%20glow%2C%20dark%20room%20and%20warm%20amber%20light%20beam%2C%20noir%20cinematic%20atmosphere&width=800&height=500&seq=ht-ch-c3&orientation=landscape",
    short: "午夜场的作者电影与经典",
    intro: "深夜电影台聚焦文艺片、作者电影与影史经典，适合喜欢安静观影与影像美学的观众。频道每期围绕一个主题，串联多部风格相近的作品。",
    tags: ["文艺", "经典修复", "主题策展"],
    reason: "策展式片单，帮你发现被忽略的宝藏影片。",
    stats: "策展主题 60+ · 双周更新",
  },
  {
    id: "c4",
    name: "环球纪实",
    cover: "https://readdy.ai/api/search-image?query=documentary%20channel%20banner%2C%20majestic%20mountain%20and%20ocean%20landscape%20at%20golden%20hour%2C%20warm%20amber%20tone%2C%20planet%20earth%20documentary%20aesthetic&width=800&height=500&seq=ht-ch-c4&orientation=landscape",
    short: "自然与人文的纪录影像",
    intro: "环球纪实收录自然、科学、历史与人文类纪录片，以高质量影像带你抵达难以亲临的世界角落，理解地球与文明的运行逻辑。",
    tags: ["自然", "人文", "4K 高清"],
    reason: "画质出众、知识密度高，纪录片爱好者的常驻地。",
    stats: "纪录专辑 90+ · 每周更新",
  },
  {
    id: "c5",
    name: "潮流综艺台",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20tv%20studio%20stage%20with%20warm%20amber%20and%20orange%20lights%2C%20energetic%20entertainment%20show%20atmosphere%2C%20modern%20set%20design&width=800&height=500&seq=ht-ch-c5&orientation=landscape",
    short: "音乐、竞技与真人秀",
    intro: "潮流综艺台汇聚音乐竞演、户外真人秀与生活类节目，紧跟当下热门话题，提供轻松解压的观看选择与每期看点速览。",
    tags: ["音乐歌舞", "真人秀", "话题热度"],
    reason: "内容轻松有热度，适合碎片时间放松观看。",
    stats: "在播综艺 40+ · 随节目更新",
  },
  {
    id: "c6",
    name: "经典修复馆",
    cover: "https://readdy.ai/api/search-image?query=retro%20cinema%20archive%20with%20vintage%20film%20reels%20and%20warm%20amber%20lighting%2C%20nostalgic%20old%20movies%20aesthetic%2C%20warm%20brown%20tones&width=800&height=500&seq=ht-ch-c6&orientation=landscape",
    short: "老片修复，重温光影记忆",
    intro: "经典修复馆专注于老电影的高清修复与整理，涵盖各个年代的华语与世界影史名作，让经典在当代技术下重新焕发魅力。",
    tags: ["影史经典", "高清修复", "怀旧"],
    reason: "修复质量高、片单体系完整，值得反复回味。",
    stats: "修复影片 150+ · 每月上新",
  },
];

export const channelTopics = [
  { id: "t1", title: "科幻迷的年度片单", desc: "从硬核设定到浪漫想象，一次看够科幻佳作。", link: "/category?category=电影&type=科幻" },
  { id: "t2", title: "悬疑推理上瘾指南", desc: "烧脑反转不停歇，挑战你的推理极限。", link: "/category?category=电影&type=悬疑" },
  { id: "t3", title: "周末合家欢观影", desc: "大人小孩都能一起看的温暖片单。", link: "/category?category=电影&type=奇幻" },
];